
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Post } from "@/lib/supabase";
import { formatDistanceToNow } from "date-fns";
import { sanitizeInput } from "@/lib/utils";

interface BlogPostCardProps {
  post: Post;
}

const BlogPostCard = ({ post }: BlogPostCardProps) => {
  const formattedDate = formatDistanceToNow(new Date(post.created_at), {
    addSuffix: true,
  });

  // Create excerpt if not provided
  const excerpt = post.excerpt || post.content.substring(0, 150).replace(/<[^>]*>/g, '') + '...';

  return (
    <Card className="h-full overflow-hidden transition-all duration-300 hover:shadow-[0_0_25px_rgba(67,255,255,0.3)] border-futuristic-border/40 hover:border-futuristic-border glass-card">
      <Link to={`/post/${post.slug}`}>
        <div className="aspect-video w-full overflow-hidden">
          <img
            src={post.thumbnail || `https://source.unsplash.com/${post.id}`}
            alt={sanitizeInput(post.title)}
            className="h-full w-full object-cover transition-transform duration-500 hover:scale-110"
            loading="lazy"
          />
        </div>
      </Link>
      <CardHeader className="p-3 sm:p-4 pb-0">
        <Link
          to={`/post/${post.slug}`}
          className="line-clamp-2 text-lg sm:text-xl font-bold tracking-tight hover:text-blog-neon transition-colors"
        >
          {post.title}
        </Link>
      </CardHeader>
      <CardContent className="p-3 sm:p-4 pt-2">
        <p className="line-clamp-3 text-sm sm:text-base text-muted-foreground">
          {sanitizeInput(excerpt)}
        </p>
      </CardContent>
      <CardFooter className="p-3 sm:p-4 pt-0 text-xs sm:text-sm text-muted-foreground">
        {formattedDate}
      </CardFooter>
    </Card>
  );
};

export default BlogPostCard;
